import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '50px',
    },
    header: {
      color: accentColor,
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 16,
    },
    table: {
      fontSize: '14px',
      display: 'flex',
      flexDirection: 'column',
    },
    tableRow: {
      display: 'grid',
      height: '36px',
      alignItems: 'center',
      gridTemplateColumns: '3fr 2fr 2fr',
      border: '1px solid #ccc',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:nth-child(odd)': { background: '#eee' },
    },
    tableCell: { '&:first-child': { 'paddingLeft': '8px' } },
    tableCellCity: {},
    tableCellCodes: {},
    tableCellLinks: {},
    bold: {
      fontWeight: 'bold',
      fontFamily: 'sans-serif',
    },
    error: { color: theme.colors.red },
    errorMessage: {
      color: theme.colors.red,
      textAlign: 'center',
      marginTop: '16px',
    },
    caution: {
      color: theme.colors.black,
      alignSelf: 'flex-start',
      marginTop: '4px',
      display: 'flex',
      justifyContent: 'center',
    },
    button: {
      margin: '10px auto',
      width: '200px',
      borderRadius: '4px',
      padding: '10px',
      backgroundColor: accentColor,
      color: theme.colors.white,
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      transition: 'filter .3s',
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
      '&:disabled': {
        color: theme.colors.white,
        backgroundColor: accentColor,
        opacity: 0.3,
      },
    },
  }
}
